import { render, staticRenderFns } from "./detailGroup.vue?vue&type=template&id=1f6d3bda"
import script from "./detailGroup.vue?vue&type=script&lang=js"
export * from "./detailGroup.vue?vue&type=script&lang=js"
import style0 from "./detailGroup.vue?vue&type=style&index=0&id=1f6d3bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports